import { React } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import MailchimpSubscribe from 'react-mailchimp-subscribe';
import { Text } from '@digsup/components-text';
import { Modal } from '@digsup/components-modal';
import { Spin } from '@digsup/components-spin';
import { PartnersForm } from './PartnersForm';

const mailchimpUrl =
  'https://digsup.us16.list-manage.com/subscribe/post?u=09496e870a7204b0145cdb0c9&amp;id=290ea2a35a';

export const PartnersModal = ({ isOpen, onClose }) => (
  <Modal
    modalIsOpen={isOpen}
    onRequestClose={onClose}
    theme="positive"
    size="medium"
    spacing="large"
    withCloseBtn>
    <MailchimpSubscribe
      url={mailchimpUrl}
      render={({ subscribe, status, message }) => (
        <>
          {!status && (
            <>
              <Modal.Header title="Become a Partner" />
              <Text color="theme-descriptive" marginBottom="medium">
                Apply to be a vetted 3rd party service provider in your area
              </Text>
              <PartnersForm onSubmit={subscribe} />
            </>
          )}

          {status === 'sending' && (
            <div className="u-padding-top-xxlarge u-padding-bottom-xxxlarge u-display-flex u-align-items-center u-justify-content-center">
              <Spin size="large" />
            </div>
          )}

          {status === 'error' && (
            <>
              <Modal.Header iconName="x" title="OOPS! Something went wrong" />
              <Text
                color="theme-descriptive"
                dangerouslySetInnerHTML={{ __html: message }}
              />
            </>
          )}

          {status === 'success' && (
            <>
              <Modal.Header
                iconName="checkmark"
                title="Your submission has been received!"
              />
              <Text color="theme-descriptive">
                We&apos;ll keep you in the know!
              </Text>
            </>
          )}
        </>
      )}
    />
  </Modal>
);

PartnersModal.propTypes = {
  /**
   * is modal open
   */
  isOpen: PropTypes.bool.isRequired,
  /**
   * close modal callback
   */
  onClose: PropTypes.func.isRequired,
};
